import { cva } from 'class-variance-authority';

export const contentVariants = cva('', {
  variants: {
    size: {
      small: [
        'py-spacing-comp-accordion-small-vertical',
        'px-spacing-comp-accordion-small-horizontal',
      ],
      medium: [
        'py-spacing-comp-accordion-medium-vertical',
        'px-spacing-comp-accordion-medium-horizontal',
      ],
    },
    noSpacing: {
      false: [],
      true: ['px-0', 'py-0'],
    },
  },
  defaultVariants: {
    size: 'medium',
    noSpacing: false,
  },
});
